module.exports = __webpack_public_path__ + "img/ofp.ddaa2a81.jpg";